module.exports = __webpack_public_path__ + "media/FormationsGeneralesEtTertiaires.022ebd3d.mp3";